__turbopack_context__.v({
  "arrowRight": "_1mSM6a_arrowRight",
  "breadcrumbItem": "_1mSM6a_breadcrumbItem",
  "breadcrumbWrapper": "_1mSM6a_breadcrumbWrapper",
  "container": "_1mSM6a_container",
  "desktop": "_1mSM6a_desktop",
  "menuItem": "_1mSM6a_menuItem",
  "menuList": "_1mSM6a_menuList",
  "menuOpenTrigger": "_1mSM6a_menuOpenTrigger",
  "mobile": "_1mSM6a_mobile",
  "mobileWrapper": "_1mSM6a_mobileWrapper",
  "offLayout": "_1mSM6a_offLayout",
  "popover": "_1mSM6a_popover",
});
